export default async element => {
	const 	{default: ScrollMagic} = await import('scrollmagic'),
			controller = new ScrollMagic.Controller();

	(new ScrollMagic.Scene({triggerElement: element, triggerHook: 0.9}))
	.on("enter", () => element.classList.add('inview'))
	.addTo(controller);

	[...element.querySelectorAll('comp-background, li')].forEach((li, index) => li.style.transitionDelay = (index * 0.75) + 's');
};